export const user_state = "user_state";

export const theme_color = "theme_color";

export const user_data = "user_data";

export const inbox_count = "inbox_count";